const originalFetch = window.fetch

let isRedirecting = false

const isAppRequest = url => {
  try {
    const parsed =
      typeof url === 'string'
        ? new URL(url, location.origin)
        : url instanceof Request
        ? new URL(url.url)
        : null
    if (!parsed) return true
    return (
      parsed.origin === location.origin &&
      !parsed.pathname.startsWith('/vite-dev')
    )
  } catch {
    return true
  }
}

window.fetch = async (...args) => {
  const response = await originalFetch(...args)
  if (response.status === 401 && !isRedirecting && isAppRequest(args[0])) {
    isRedirecting = true
    localStorage.setItem('isLoggedIn', 'false')
    location.href = '/v2/login'
  }
  return response
}
